import script from "./PublicId.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublicId.vue?vue&type=script&lang=ts&setup=true"

import "./PublicId.vue?vue&type=style&index=0&id=6ea41d7a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea41d7a"]])

export default __exports__